import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../../localization/labels";
import { activeFilter } from "../../../../../services/FilteringUtils";
import InvolvementRoleTypeService from "../../../../../services/InvolvementRoleTypeService";
import OperationService from "../../../../../services/OperationService";
import CommonUtil from "../../../../../utils/CommonUtil";
import PathUtil from "../../../../../utils/PathUtil";
import {
  involvementRoleTypeValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import { paths } from "../../../../paths";
import SubControlComponent from "../../../page/SubControlComponent";
import InvolvementRoleType from "./InvolvementRoleType";

class InvolvementRoleTypeContainer extends SubControlComponent {
  constructor(props) {
    super(props);

    this.state = {
      id: this.resolveItemId(),
      isChanged: false
    };
    this.state = this.initialState(this.state);

    this.involvementRoleTypeService = new InvolvementRoleTypeService(
      this.keycloak
    );
    this.operationService = new OperationService(this.keycloak);
  }

  initialState = state => {
    return {
      ...state,
      entity: { operations: [] },
      oldEntity: undefined,
      disabled: true,
      isNew: true
    };
  };

  getComponentTitle = () => {
    return this.state.entity ? this.state.entity.name : undefined;
  };

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  loadData = () => {
    if (this.state.id) {
      this.loadInvolvementRoleType(this.state.id);
    } else {
      this.setComponentTitle(labels.involvementRoleType);
    }
  };

  loadInvolvementRoleType = id => {
    this.prepareCall(
      this.involvementRoleTypeService.getEntityById(
        id,
        this.onLoadInvolvementRoleType,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadInvolvementRoleType = data => {
    this.resetFlags = this.setResetFlags(true);

    this.setState({
      entity: { ...data },
      oldEntity: { ...data },
      disabled: false,
      isNew: false
    });
    this.loadEntityOperations(data._links.operations.href);
  };

  loadEntityOperations = url => {
    this.prepareCall(
      this.operationService.getEntitiesWithParams(
        url,
        activeFilter,
        undefined,
        this.onEntityOperationsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  getSubArraysPaths = () => {
    return ["operations"];
  };

  onEntityOperationsLoad = data => {
    const { entity } = this.state;
    entity.operations = CommonUtil.getDataContent(data) || [];
    this.setState({ entity });
  };

  handleDialogChange = event => {
    let { entity } = this.state;
    const path = event.target.id;
    CommonUtil.setDeepOnStringPath(entity, path, event.target.value);
    const disabled = !this.validator(entity);
    this.setState({ entity, disabled });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  saveNewEntity = entity => {
    this.prepareCall(
      this.involvementRoleTypeService.postEntity(
        entity,
        this.onSaveLoad,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  updateEntity = entity => {
    this.prepareCall(
      this.involvementRoleTypeService.putEntity(
        entity,
        this.onSaveLoad,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  onSaveLoad = data => {
    if (this.state.id) {
      this.loadData();
    } else {
      const itemPath = PathUtil.adminItemsPath(
        { path: paths.INVOLVEMENTROLETYPES },
        { path: paths.DETAIL, id: data.id }
      );
      this.changePath(itemPath, labels.involvementRoleType);
    }
  };

  render() {
    return (
      <InvolvementRoleType
        {...this.renderProps()}
        involvementRoleType={this.state.entity}
        messageHandler={this.messageHandler}
        breadcrumbsHandler={this.breadcrumbsHandler}
        disabled={this.state.disabled}
        onChange={this.handleDialogChange}
        validationRules={validationRules.generalData}
        removeFromOperationsTable={element =>
          this.removeFromSubArray(this.getSubArraysPaths()[0], element)
        }
        addToOperationsTable={element =>
          this.addToSubArray(this.getSubArraysPaths()[0], element)
        }
        updateInOperationsTable={element =>
          this.replaceInSubArray(this.getSubArraysPaths()[0], element)
        }
        resetOperations={this.resetFlags[this.getSubArraysPaths()[0]]}
      />
    );
  }
}

export default withKeycloak(InvolvementRoleTypeContainer);
